<template>
    <div class="">
        <div v-for="element in question.options.elements" :key="element.index">
            <div class="p-4 flex items-center gap-2">
                <span class="font-semibold"> {{ element.letter }}) </span>
                <span><LatexMaybe :model-value="element.text" :is-latex="question.is_latex_answers" /></span>
            </div>
        </div>

        <QuestionGeneralReview :question="question" :students="students" :with-percent="withPercent" />
    </div>
</template>

<script>
import QuestionGeneralReview from '@/components/Quiz/Review/QuestionGeneralReview.vue';
import LatexMaybe from '../../LatexMaybe.vue';

export default {
    name: 'QuestionOrderElementsReview',
    components: {
        LatexMaybe,
        QuestionGeneralReview,
    },
    props: {
        question: {
            required: true,
        },
        withPercent: {
            required: false,
            default: false,
            type: Boolean,
        },
        students: {
            required: true,
            type: Array,
        },
    },
};
</script>
